import React from 'react'

const BlogList = () => {
  return (
    <div>BlogList</div>
  )
}

export default BlogList